import makeStyles from "@material-ui/core/styles/makeStyles";
import { createStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      width: 120
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    },
    dropDownField: {
      fontSize: "0.9rem",
      marginLeft: "5px",
      width: "100%"
    },
    inputField: {
      width: "150px",
      marginLeft: "5px"
    },
    denominationsButton: {
      marginLeft: "5px",
      color: "goldenrod",
      border: "2px solid gray",
      backgroundColor: "transparent",
      marginTop: "5px",
      borderRadius: "5px",
      cursor: "pointer",
      padding: "2px 4px 2px 4px"
    },
    datePickerMargin: {
      margin: "0"
    },
    gbpAmountText: {
      color: "darkblue",
      fontWeight: "bold",
      fontSize: "0.9rem",
      marginLeft: "5px",
      marginTop: "5px"
    },
    errorMsg: {
      width: "150px",
      marginLeft: "5px"
    },
    button: {
      borderRadius: "5px",
      fontSize: "0.9rem"
    },
    clearFormButton: {
      borderRadius: "5px",
      fontSize: "0.9rem",
      marginRight: "5px"
    },
    titleBar: {
      textAlign: "start",
      backgroundColor: "#869ac4"
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff"
    }
  })
);
